import NotifierWrapper from '@/components/ui/notifier/notifier-wrapper';
import { ENUM__component_type } from '@/enums/ENUM__component_type';
import { HOOK__notifier } from '@/hooks/HOOK__notifier';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__workspace_entity } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { format_timestamp_YY_MM_DD_HH_mm_ss } from '@shared/utils/utils_time';
import { useTranslation } from 'react-i18next';

interface Props {
  item: DTO__user_task;
  is_any_generation_in_progress: boolean;
}

export const U_LABEL__user_task_name: React.FC<Props> = ({ item, is_any_generation_in_progress }) => {
  const { t } = useTranslation(ENUM__i18n_namespace.USER_TASK);

  const component_id = `${ENUM__component_type.PAGE_USER_TASKS_LIST_ITEM_TITLE}_${item._id}`;
  const notifier = HOOK__notifier(component_id, ENUM__workspace_entity.ENTITY_USER_TASK);

  return (
    <NotifierWrapper
      className={`text-left m-0 truncate whitespace-nowrap w-full 
       ${is_any_generation_in_progress ? '!text-purchase' : ''}`}
      notifier={notifier}
    >
      {item.name.is_blank() ? format_timestamp_YY_MM_DD_HH_mm_ss(item.created_at) : item.name}
    </NotifierWrapper>
  );
};
